var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFw1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #003189;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gallery_icon_arrow",
    "data-name": "gallery icon arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7021-2",
    "data-name": "Path 7021-2",
    className: "cls-1",
    d: "m27.5,55C12.31,55,0,42.69,0,27.5S12.31,0,27.5,0s27.5,12.31,27.5,27.5-12.31,27.5-27.5,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8564",
    "data-name": "Path 8564",
    className: "cls-2",
    d: "m30.08,29.33l1.82-1.82-5.93-5.93c-.07-.07-.15-.15-.23-.22-.36-.33-.88-.41-1.32-.19-.48.2-.79.66-.8,1.18,0,.38.16.74.45.98l6.01,6.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8565",
    "data-name": "Path 8565",
    className: "cls-2",
    d: "m31.9,27.5l-1.82-1.82c-2.86,2.86-3.08,3.08-5.93,5.93-.07.07-.15.15-.22.23-.33.36-.41.88-.19,1.32.2.48.66.79,1.18.8.38,0,.74-.16.98-.45l6.01-6.01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFw1);
export default __webpack_public_path__ + "static/media/ico-fw-1.90095d9bb5592113a00656906da16628.svg";
export { ForwardRef as ReactComponent };